import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
const projects = [{
  category: 'Custom Wood Ceiling',
  gradient: 'from-amber-200 to-orange-100'
}, {
  category: 'Feature Wall',
  gradient: 'from-orange-100 to-amber-50'
}, {
  category: 'Door Installation',
  gradient: 'from-stone-200 to-stone-100'
}, {
  category: 'Trim Work',
  gradient: 'from-orange-200 to-orange-100'
}, {
  category: 'Panel System',
  gradient: 'from-amber-100 to-yellow-50'
}, {
  category: 'Custom Build',
  gradient: 'from-stone-300 to-stone-200'
}];
export function PortfolioSection() {
  return <section id="portfolio" className="py-24 bg-white" data-id="element-152">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-154">
          <div data-id="element-155">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-sunrise-charcoal mb-4" data-id="element-156">
              Recent Projects
            </h2>
            <p className="text-lg text-gray-600 max-w-xl" data-id="element-157">
              A showcase of our finest finish carpentry work across the valley.
            </p>
          </div>
          <div className="hidden md:block" data-id="element-158">
            <Button variant="outline" className="group" data-id="element-159">
              View All Projects{' '}
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-160" />
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-161">
          {projects.map((project, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative group overflow-hidden rounded-xl bg-gradient-to-br ${project.gradient} aspect-[4/3]`} data-id="element-162">
              {/* Decorative pattern to simulate texture */}
              <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/wood-pattern.png')]" data-id="element-163" />

              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-sunrise-brown/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-164">
                <div className="text-center transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-165">
                  <span className="block text-sunrise-gold font-medium tracking-wider text-sm uppercase mb-2" data-id="element-166">
                    Project Type
                  </span>
                  <h3 className="font-heading text-2xl text-white font-bold" data-id="element-167">
                    {project.category}
                  </h3>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 md:hidden text-center" data-id="element-168">
          <Button variant="outline" className="w-full" data-id="element-169">
            View All Projects
          </Button>
        </div>
      </div>
    </section>;
}